export default {
  actions: {
    Register(ctx, data) {
      ctx.commit('updateEmailError', '');
      ctx.commit('updatePasswordError', '');
      ctx.commit('updateNameError', '');
      axios
        .post(data.path + '/users', {
          headers: {
            'Content-Type': 'application/json'
          },
          'email': data.email,
          'f_name': data.f_name,
          'password': data.password,
          'ad_mailings': data.ad_mailings,
          'password_confirmation': data.password_confirmation,
          'cart_id': localStorage.getItem('cart_id'),
        })
        .then(response => {
          localStorage.setItem('access_token', response.data.token.access_token);
          localStorage.setItem('refresh_token', response.data.token.refresh_token);
          localStorage.setItem('user', JSON.stringify(response.data.data));
          ctx.commit('updateIsAuthStatus');
          ctx.commit('updateAuthUser', response.data.data);
          let langg = 'en';
          if (!!data.currentLang) {
            langg = data.currentLang;
          }
          let href = `/${langg}/profile`;
          if (localStorage.getItem('checkout_started')) {
            localStorage.removeItem('checkout_started')
            href += '?checkout'
          }
          window.location.replace(href);
          this._vm.$gtag.event('sign_up', {
            method: 'Email',
          })
          setTimeout(() => {
            if (window.fbq) {
              window.fbq('track', 'CompleteRegistration', {
                status: true,
                currency: "EUR",
                content_name: 'Email'
              })
            }
          })
        })
        .catch(err => {
          console.err('Register error:', err)
          if (err.response.data && err.response.data.errors.email) {
            ctx.commit('updateEmailError', err.response.data.errors.email[0])
          } else if (err.response.data && err.response.data.errors.password) {
            ctx.commit('updatePasswordError', err.response.data.errors.password[0])
          } else if (err.response.data && err.response.data.errors.f_name) {
            ctx.commit('updateNameError', err.response.data.errors.f_name[0])
          }
          setTimeout(function () {
            ctx.commit('updateEmailError', '');
            ctx.commit('updatePasswordError', '');
            ctx.commit('updateNameError', '');
          }, 5000)
        })
    }
  },
  mutations: {
    updatePasswordError(state, err) {
      state.PasswordError = err
    },
    updateNameError(state, err) {
      state.NameError = err
    }
  },
  state: {
    PasswordError: '',
    NameError: '',
    isRunCheckout: !!localStorage.getItem('isRunCheckout')
  },
  getters: {
    getPasswordError(state) {
      return state.PasswordError
    },
    getNameError(state) {
      return state.NameError
    },

  }
}
